import alpha from "color-alpha";
const MuiIconButton = {
  defaultProps: {
    size: "lg"
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      backgroundColor: theme.palette.primary["800"],
      color: theme.palette.common.white,
      boxShadow: theme.shadows["8"],
      transition: "150ms",
      overflow: "hidden",
      "&:hover": {
        backgroundColor: "#148C79",
        boxShadow: theme.shadows["9"]
      },
      "&:focus": {
        backgroundColor: "#1f8371",
        boxShadow: theme.shadows["8"]
      },
      "&:active": {
        backgroundColor: theme.palette.primary["800"],
        boxShadow: theme.shadows["8"]
      },
      "&:disabled": {
        backgroundColor: alpha(theme.palette.grey["600"], 0.12),
        color: alpha(theme.palette.grey["800"], 0.38),
        boxShadow: "none"
      },
      "& .MuiTouchRipple-root": {
        top: "-16%",
        right: "-16%",
        bottom: "-16%",
        left: "-16%",
        "& .MuiTouchRipple-ripple": {
          color: theme.palette.grey["900"],
          opacity: 0.12
        }
      },
      ...ownerState.color === "transparent" && {
        backgroundColor: "transparent",
        boxShadow: "none",
        color: theme.palette.grey["900"],
        "&:hover, &:focus, &:active, &:disabled": {
          color: theme.palette.grey["900"],
          backgroundColor: "transparent",
          boxShadow: "none"
        },
        "&&:disabled": {
          color: alpha(theme.palette.grey["800"], 0.38)
        },
        "&& .MuiTouchRipple-root": {
          "& .MuiTouchRipple-ripple": {
            opacity: 0
          }
        }
      },
      ...ownerState.size === "md" && {
        minWidth: "28px",
        height: "28px",
        borderRadius: "8px",
        padding: "8px"
      },
      ...ownerState.size === "sm" && {
        minWidth: "18px",
        height: "18px",
        borderRadius: "4px",
        padding: "4px"
      },
      ...ownerState.size === "lg" && {
        minWidth: "56px",
        height: "56px",
        borderRadius: "16px",
        padding: "16px"
      },
      ...ownerState.size === "xl" && {
        minWidth: "96px",
        height: "96px",
        borderRadius: "28px",
        padding: "30px"
      }
    })
  }
};
export {
  MuiIconButton
};
